<div class="" style="padding: 0 60px;">
    <h6 class="mt-3" style="color:#126db3;margin-left: -15px;">{{"action_plan.members.title"  | translate}}</h6>
    <div class="row mb-2 bg-white p-4">
        <div class="col-12 col-lg-6">
            <div class="col-12 d-flex">
                <h6 style="color: #126db3;margin-top:4px;margin-left: -15px;">
                    {{"action_plan.members.leader" | translate}} </h6>
                <button class="fa-stack fa-1x ml-2 cursor"
                    style="font-size: 13px;margin-top:2px;border:none;background: none;outline: none;"
                    (click)="openConfiguration('lider')" [disabled]="fromHistoric">
                    <i class="fa fa-circle fa-stack-2x icon-background"></i>
                    <i class="fas fa-plus fa-stack-1x"></i>
                </button>
            </div>
            <div class="col-12 form-grey p-4 box" style="max-height: 150px;overflow-y: auto;overflow-x: hidden;">
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngFor="let leader of leaders">
                            <div class="row hover">
                                <div class="col-12 d-flex justify-content-between">
                                    {{leader.nombre}}
                                    <button class="fa-stack fa-1x ml-2 cursor"
                                        style="font-size: 13px;border:none;background: none;outline: none;"
                                        (click)="removeMember(leader,'lider')" [disabled]="fromHistoric">
                                        <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                        <i class="fas fa-times fa-stack-1x"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 mt-3 mt-lg-0">
            <div class="col-12 d-flex">
                <h6 style="color: #126db3;margin-top:4px;margin-left: -15px;">
                    {{"action_plan.members.guest" | translate}}</h6>
                <button class="fa-stack fa-1x ml-2 cursor"
                    style="font-size: 13px;margin-top: 2px;border:none;background: none;outline: none"
                    (click)="openConfiguration('guest')" [disabled]="fromHistoric">
                    <i class="fa fa-circle fa-stack-2x icon-background"></i>
                    <i class="fas fa-plus fa-stack-1x"></i>
                </button>
            </div>
            <div class="col-12 form-grey p-4 box" style="max-height: 150px;overflow-y: auto;overflow-x: hidden;">
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngFor="let guest of guests">
                            <div class="row hover">
                                <div class="col-12 d-flex justify-content-between">
                                    {{guest.nombre}}
                                    <button class="fa-stack fa-1x ml-2 cursor"
                                        style="font-size: 13px;border:none;background: none;outline: none"
                                        (click)="removeMember(guest,'guest')" [disabled]="fromHistoric">
                                        <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                        <i class="fas fa-times fa-stack-1x"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>